export const posts = [
    {
        title: 'Managing state with useReducer, useState',
        desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolorum doloremque voluptatem in at minus mollitia. Labore aperiam illo mollitia accusamus laborum, error, repellendus voluptatum adipisci quaerat quae quas a.',
        img: 'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGNvZGV8ZW58MHx8MHx8fDA%3D',
        url: ''
    },
    {
        title: 'Handling UX with EJS',
        desc: 'First of all, let’s start with a basic idea: What is EJS or a view engine? 🤔 When dealing with server-side development, we often need to generate dynamic HTML content. Instead of writing HTML code manually for every possible outcome, we use a view engine to create templates that the server can fill with data on-the-fly. This is where EJS (Embedded JavaScript) comes into play. ✨',
        img: 'https://miro.medium.com/v2/resize:fit:720/format:webp/1*HgIQSfjkIwhJKVww_Tet8w.png',
        url: 'https://medium.com/@ayushk3609/use-of-view-engines-like-ejs-95c1e561c80b'
    },
    {
        title: 'Top React-18 features',
        desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolorum doloremque voluptatem in at minus mollitia. Labore aperiam illo mollitia accusamus laborum, error, repellendus voluptatum adipisci quaerat quae quas a.',
        img: 'https://www.clariontech.com/hubfs/React%2018%20New%20Features.jpg',
        url: ''
    },
    {
        title: 'Optimising your react loading',
        desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolorum doloremque voluptatem in at minus mollitia. Labore aperiam illo mollitia accusamus laborum, error, repellendus voluptatum adipisci quaerat quae quas a.',
        img: 'https://res.cloudinary.com/cloudinary-marketing/images/w_2000,h_1100/f_auto,q_auto/v1649726043/Web_Assets/blog/Lazy-Loading-React_2209601c04/Lazy-Loading-React_2209601c04-png?_i=AA',
        url: ''
    },
]